// react
import React from "react"
import { connect } from "react-redux"
import { browserHistory } from "react-router"


export default (Component, mustBeAdmin = false) => {
    class AuthenticatedComponent extends React.Component {
        componentWillMount () {
            this.authenticate(this.props.isAuthenticated)
        }

        componentWillReceiveProps (nextProps) {
            this.authenticate(nextProps.isAuthenticated)
        }

        authenticate(isAuthenticated) {
            if (isAuthenticated !== true) {
                const redirect = this.props.location.pathname
                browserHistory.replace(`/login?next=${redirect}`)
            }
        }
        
        render () {
            if (this.props.isAuthenticated === true)
                if (!mustBeAdmin || this.props.isAdmin)
                    return <Component {...this.props} />

            return null
        }
    }

    function mapStateToPros(state) {
        return {
            isAdmin: state.user.get("admin") === 1,
            isAuthenticated: (state.user.get("id") !== 0)
        }
    }

    return connect(mapStateToPros)(AuthenticatedComponent)
}


/** WEBPACK FOOTER **
 ** ./src/containers/Authenticate/authenticate-component.js
 **/